import clickOutside from "./clickOutside.js";
import preventEvent from "./preventEvent.js";
import elTablelnfiniteScroll from "el-table-infinite-scroll";
const setupDirective = (app) => {
  app.directive("click-outside", clickOutside);
  app.directive("prevent-event", preventEvent);
  app.directive("el-table-infinite-scroll", elTablelnfiniteScroll);
};

export default setupDirective;
